import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, MarkerClusterer } from '@react-google-maps/api';
import blueIcon from './blue_icon';
import orangeIcon from './orange_icon';
import { getContent } from '../../common/content';

import { useContext } from 'react';
import { Context } from '../../store/context';

const optionsCluster = {
  imagePath:
    'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
};

function DropPointsMap({ isLoaded, dropPoints, onBoundsChanged }) {
  const [infoWindow, setInfoWindow] = useState();
  const {
    map,
    mapMarkers,
    setMap,
    setMapmarkers,
    setActivemarkerid,
    center,
    lastZoom,
    setLastCenter,
  } = useContext(Context);
  const onLoad = React.useCallback(function callback(map) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        let initialLocation = new window.google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        map.setCenter(initialLocation);
        setLastCenter({
          lat: initialLocation.lat(),
          lng: initialLocation.lng(),
        });
      });
    } else {
      setLastCenter(center);
    }

    setInfoWindow(new window.google.maps.InfoWindow());
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  const handleCloseMarker = () => {
    setActivemarkerid(null);
    map.setCenter(window.lastCenter);
    map.setZoom(lastZoom);
  };

  const onLoadMarker = (marker, point) => {
    marker.id = point.id;
    let mapMarkersLocal = mapMarkers;
    mapMarkersLocal.push(marker);
    setMapmarkers([...mapMarkersLocal]);

    marker.addListener('click', async () => {
      map.setCenter(marker.getPosition());
      map.setZoom(17);
      marker.setIcon(orangeIcon);

      infoWindow.setContent(getContent(point));
      infoWindow.open({
        anchor: marker,
        map: map,
        shouldFocus: false,
      });
      setActivemarkerid(point.id);
      window.google.maps.event.clearInstanceListeners(infoWindow);
      infoWindow.addListener('closeclick', () => {
        handleCloseMarker();
      });
    });

    marker.addListener('mouseover', async () => {
      const markerlabel = {
        text: point.label,
        color: 'black',
        className: `marker-label-class`,
      };
      marker.setLabel(markerlabel);
    });
    marker.addListener('mouseout', async () => {
      marker.setLabel(null);
    });
  };

  return (
    <>
      {isLoaded === true ? (
        <GoogleMap
          id="puntos-droop"
          mapContainerStyle={{
            width: '100%',
            height: '100%',
          }}
          zoom={10}
          center={center}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onBoundsChanged={onBoundsChanged}
        >
          <MarkerClusterer options={optionsCluster}>
            {(clusterer) =>
              dropPoints.map((point, index) => (
                <Marker
                  key={`${point.daneCiudad}_${index}`}
                  id={point.id}
                  position={point}
                  icon={blueIcon}
                  onLoad={(marker) => onLoadMarker(marker, point)}
                  clusterer={clusterer}
                />
              ))
            }
          </MarkerClusterer>
        </GoogleMap>
      ) : null}
    </>
  );
}

DropPointsMap.propTypes = {
  isLoaded: PropTypes.bool,
  dropPoints: PropTypes.array,
  setMapMarkers: PropTypes.func,
  setMap: PropTypes.func,
  onBoundsChanged: PropTypes.func,
};

export default DropPointsMap;
